import { FormControl, MenuItem, Paper, Select, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useStore } from "store/StoreConfigs";
import { assignEventMenuStyles } from "./AssignEventMenuStyles";
import { ReactComponent as AssignEventMenuCloseBtn } from "icons/AssignEventMenuCloseBtn.svg";
// import { ReactComponent as AssignMenuSearchArrow } from "icons/AssignMenuSearchArrow.svg";
import { EventStatus } from "models/thorEventModels/EventDetails";
import { ReactComponent as FilterDownArrow } from "icons/FilterDownArrow.svg";
import { LynxInput } from "components/LynxInput/LynxInput";
import CustomerIdRequest from "api/sharedModels/CustomerIdRequest";

export interface AssignEventMenuProps {
    eventId: number;
    reviewerUserId: string;
    qaUserId: string;
    eventStatusId: number;
}

export default observer(function AssignEventMenu({
    eventId,
    reviewerUserId,
    qaUserId,
    eventStatusId,
}: AssignEventMenuProps) {
    const classes = assignEventMenuStyles();
    const { thorEventViewStore, userStore, identityStore } = useStore();

    useEffect(() => {
        const request: CustomerIdRequest = {
            customerId: identityStore.currentCustomerId,
        };

        userStore.loadValidUsers(request);
    }, []);

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        thorEventViewStore.assignUserToEvent({
            userId: event.target.value as string,
            assignUserType: eventStatusId === EventStatus.New ? 1 : 2,
            eventId: eventId,
            customerId: identityStore.currentCustomerId,
        });
    };

    return (
        <Paper className={classes.menu}>
            {eventStatusId === EventStatus.New && (
                <AssignEventMenuCloseBtn
                    className={classes.closeIcon}
                    onClick={() => {
                        thorEventViewStore.setAssignMenuOpen(false);
                    }}
                />
            )}
            <div className={classes.innerMenu}>
                <div className={classes.textContainer}>
                    <Typography variant="h3">Assign this Event</Typography>
                    <Typography className={classes.subText}>
                        Choose an <span style={{ fontWeight: 600 }}>assessor</span> whom you`d like to assign this event
                    </Typography>
                </div>
                <div className={classes.searchContainer}>
                    {/* <Typography>Search for a user to assign</Typography>
                    <TextField
                       
                        variant="outlined"
                        label="Enter name or email"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Button
                                        
                                        className={classes.searchIcon}
                                    >
                                        <AssignMenuSearchArrow />
                                    </Button>
                                </InputAdornment>
                            ),
                        }}
                    /> */}
                </div>

                <FormControl className={classes.formControl}>
                    <Typography>{eventStatusId === EventStatus.New ? "Select a reviewer" : "Select a QA"}</Typography>
                    <Select
                        IconComponent={FilterDownArrow}
                        value={eventStatusId === EventStatus.New ? reviewerUserId : qaUserId}
                        input={<LynxInput />}
                        onChange={handleChange}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                            },
                            getContentAnchorEl: null,
                            style: {
                                marginTop: 1,
                                maxHeight: 300,
                            },
                        }}
                    >
                        {userStore.validUsers.map((user) => (
                            <MenuItem
                                className={classes.menuItem}
                                classes={{ selected: classes.selected }}
                                key={user.id}
                                value={user.email}
                            >
                                {user.firstName + " " + user.lastName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </Paper>
    );
});
